import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipCardQueryCriteriaClass extends BaseCriteriaModel {
  //for header
  contact_key_guid?: Optional<string> = Optional.empty();
  card_no?: Optional<string> = Optional.empty();
  login_subject_guid?: Optional<string> = Optional.empty();
  start_date?: Optional<string> = Optional.empty();
  end_date?: Optional<string> = Optional.empty();
  entity_hdr_guids?: Optional<string[]> = Optional.empty();

  created_from?: Optional<string> = Optional.empty();
  created_to?: Optional<string> = Optional.empty();

  //for extension
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class MembershipCardCriteriaModelQuery {
  query = '';

  constructor(MembershipCardCriteriaModel: MembershipCardQueryCriteriaClass) {

    if (!MembershipCardCriteriaModel) {
      return;
    }

    this.query += MembershipCardCriteriaModel.contact_key_guid.filter(x => x !== '').map(x => '&contact_key_guid=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.card_no.filter(x => x !== '').map(x => '&card_no=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.start_date.filter(x => x !== '').map(x => '&start_date=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.end_date.filter(x => x !== '').map(x => '&end_date=' + x).orElse('');
    
    //this.query += MembershipCardCriteriaModel.entity_hdr_guids.filter(x => x !== '').map(x => '&entity_hdr_guid=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.entity_hdr_guids.filter(x => x !== []).map(x => '&entity_hdr_guids='+ 
    x.join(',')).orElse('');

    this.query += MembershipCardCriteriaModel.created_from.filter(x => x !== '').map(x => '&created_from=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.created_to.filter(x => x !== '').map(x => '&created_to=' + x).orElse('');

    this.query += MembershipCardCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += MembershipCardCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + MembershipCardCriteriaModel.status;
    this.query += '&orderBy=' + MembershipCardCriteriaModel.orderBy;
    this.query += '&order=' + MembershipCardCriteriaModel.order;
    this.query += '&offset=' + MembershipCardCriteriaModel.offset + '&limit=' + MembershipCardCriteriaModel.limit;
  }
}

